import React from "react";
import { Switch, Route } from "react-router-dom";
import ShowAddress from "./ShowAddress";
import EditAddress from "./EditAddress";

function Address() {
  return (
    <div className="container row">
      <Switch>
        <Route
          path={`/profile/address/:id`}
          render={(props) => <EditAddress {...props} />}
        />
        <Route
          exact
          path="/profile/address"
          render={(props) => <ShowAddress {...props} />}
        />
      </Switch>
    </div>
  );
}

export default Address;
